import type {
  FicIdentityReviewItem,
  FicResourceFreshness,
} from "@cem/contracts";

export const ficReviewCount = (resource: FicResourceFreshness): string => {
  const count = resource.pendingAssociations;
  if (count === undefined) return "Verifica delle associazioni non disponibile";
  switch (resource.resource) {
    case "clients":
      return `${count} ${count === 1 ? "identità cliente FIC da verificare" : "identità clienti FIC da verificare"}`;
    case "quotes":
      return `${count} ${count === 1 ? "preventivo senza cliente confermato" : "preventivi senza cliente confermato"}`;
    case "documents":
      return `${count} ${count === 1 ? "documento da associare alla commessa" : "documenti da associare alle commesse"}`;
    case "catalog":
      return `${count} voci catalogo da verificare`;
  }
};

export const ficPendingSummary = (resources: FicResourceFreshness[]): string =>
  resources
    .filter((r) => (r.pendingAssociations ?? 0) > 0)
    .map(ficReviewCount)
    .join(" · ");

export const ficReviewTarget = (resource: FicResourceFreshness): string =>
  resource.resource === "documents"
    ? "fic-document-review"
    : "fic-identity-review";

export const describeFicIdentity = (
  item: FicIdentityReviewItem,
): { reason: string; action: string } => {
  if (!item.needsReview)
    return {
      reason: "Associazione locale confermata.",
      action:
        "La scelta è conservata per i prossimi aggiornamenti FIC. Cambiala solo dopo aver verificato i dati del cliente.",
    };
  if (item.kind === "quote")
    return {
      reason:
        item.reviewReason === "quote-choice-invalid"
          ? "La precedente associazione non è più valida: sono cambiati i dati del destinatario o lo stato del cliente scelto."
          : item.reviewReason === "quote-client-id-missing"
            ? "Nel preventivo FIC manca l'ID del cliente." +
              (!item.sourceIdentity?.taxCode && !item.sourceIdentity?.vatNumber
                ? " Mancano anche codice fiscale e partita IVA: il solo nome non consente un'associazione certa."
                : " I dati fiscali disponibili sono riportati qui sotto per il confronto.")
            : item.reviewReason === "quote-client-unresolved"
              ? "Il cliente indicato nel preventivo FIC non corrisponde a un collegamento locale univoco."
              : "Il destinatario di questo preventivo FIC non ha un'associazione cliente locale confermata.",
      action:
        item.candidateIds.length === 0
          ? "Apri Clienti e condomini e verifica o crea l'anagrafica del destinatario. Poi ricarica questa verifica e selezionala."
          : "Verifica il destinatario e l’immobile nel preventivo FIC, confrontali con Clienti e condomini, poi seleziona qui l’anagrafica corretta e premi Conferma associazione. Se manca, completa prima l’anagrafica. La scelta resta salvata in CEM anche se il preventivo FIC non contiene l’ID cliente.",
    };
  return {
    reason:
      item.candidateIds.length > 1
        ? `${item.candidateIds.length} anagrafiche CEM indicano lo stesso cliente FIC. Il gestionale non può scegliere quale utilizzare.`
        : "La precedente scelta del cliente FIC non è più valida o non è univoca.",
    action:
      item.candidateIds.length === 0
        ? "Nessuna anagrafica attiva è selezionabile. Verifica lo stato del cliente in Clienti e condomini, poi ricarica la verifica."
        : "Confronta codice fiscale e partita IVA con la scheda cliente in FIC. Scegli qui l'anagrafica CEM corrispondente e premi Conferma associazione. Se i dati non coincidono, correggi prima l'anagrafica; il solo nome non basta.",
  };
};
